<template>
  <DialogInfo :visible="visible" @hidden="updateVmodel" :title="question.title">
    <b-alert show>{{ question.question }}</b-alert>
    <b-table
      responsive
      striped
      head-variant="dark"
      :items="items"
      :fields="fields"
    ></b-table>
  </DialogInfo>
</template>

<script>
export default {
  name: "SurveyAnswerListDialog.vue",
  props: {
    visible: {
      default: false
    },
    question: {
      default: null
    },
    answers: {
      default: null
    }
  },
  model: {
    prop: "visible",
    event: "hidden"
  },
  data() {
    return {
      fields: []
    };
  },
  computed: {
    items() {
      if (this.answers == null || this.answers.length == 0) {
        return [];
      }

      var keys = Object.keys(this.answers);
      var list = [];
      keys.forEach(key => {
        list.push({
          team_name: this.$store.getters["teamStore/teamNames"](key),
          answer: this.answers[key]
        });
      });

      var sortedTeams = this.$_.sortBy(list, [
        team => team.team_name.toLowerCase()
      ]);

      return sortedTeams;
    },
    sortedAnswers() {
      return null;
    }
  },
  created() {
    this.fields = [];
  },
  methods: {
    updateVmodel() {
      this.$emit("hidden", false);
    }
  }
};
</script>
